import React from 'react';

import PageTemplate, {
  pageCommonPropTypes,
  renderCmsComponents,
} from './templates/PageTemplate';

const CategoryPage = ({ content = {}, fpti = {}, pageInfo = {} }) => {
  const { header, footer } = content.globalComponents || {};
  const {
    components = [],
    subNav,
    globalDisclosure,
    articleStickyButton,
  } = content.pageData || {};

  return (
    <PageTemplate
      header={header}
      footer={footer}
      fpti={fpti}
      subNav={subNav}
      pageInfo={pageInfo}
      globalDisclosure={globalDisclosure}
      articleStickyButton={articleStickyButton}
    >
      {renderCmsComponents(components, pageInfo)}
    </PageTemplate>
  );
};

CategoryPage.propTypes = pageCommonPropTypes;

export default CategoryPage;
